import Hero from "../Component/Hero";
import DownloadAppSection from "../../../Components/DownloadAppSection";
import PengajuanPinjaman from "../Component/PengajuanPinjaman";
import PersyaratanPinjaman from "../Component/PersyaratanPinjaman";
import React from "react";
import CardDokumenPendukung from "../Component/CardDokumenPendukung";
import Table from "../Component/Table";
import Riplay from "../Component/Riplay";

function KreditMultiGuna() {
    return (
        <>
            <div>
                <Hero
                    imageClass='kmg'
                    title='Kredit Multiguna'
                    subTitle='P I N J A M A N &emsp;I N D I V I D U'
                    explanation='Adalah fasilitas pinjaman dengan jaminan tanah dan bangunan yang dapat digunakan secara fleksibel untuk berbagai macam keperluan, dengan limit pinjaman sampai dengan Rp2.000.000.000,- dan jangka waktu pinjaman sampai 5 tahun.'
                    buttonText='AJUKAN PINJAMAN'
                />
                <Table type='individu' title='kmg'/>
                {/* <PersyaratanPinjaman type='individu'/>
                <CardDokumenPendukung type='individu'/> */}
                <PengajuanPinjaman type='individu' product='kmg'/>
                <Riplay type='individu' product='kmg'/>
                <DownloadAppSection/>
            </div>
        </>
    );
}

export default KreditMultiGuna;
